import { render, staticRenderFns } from "./CommissionTeamItem.vue?vue&type=template&id=7b801118&scoped=true"
import script from "./CommissionTeamItem.vue?vue&type=script&lang=js"
export * from "./CommissionTeamItem.vue?vue&type=script&lang=js"
import style0 from "./CommissionTeamItem.vue?vue&type=style&index=0&id=7b801118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b801118",
  null
  
)

export default component.exports